import React                    from 'react';

import * as AgencyType          from 'shared/types/Agency';
import * as UserType            from 'shared/types/User';
import * as hhmmUtil            from 'shared/utils/hhmm';
import dayjs                    from 'shared/utils/day-timezone';

import * as MenuItem            from 'components/MenuItem';
import tectransit               from 'utils/TecTransit';
import getApiPromise            from 'utils/getApiPromise';

interface Props {
    type : ('fixedroute'|'ondemand');
}
const Schedule : React.FC<Props> = props => {
    const [refreshCount,setRefreshCount] = React.useState<number>(0);
    const [user,setUser]                 = React.useState<UserType.Hydrated>(tectransit.user);
    const [errMessage,setErrMessage]     = React.useState<string>('');
    React.useEffect(() => {
        // Just re-read the user from the backend to avoid any caching errors
        getApiPromise<UserType.Dehydrated>('/api/passenger/user','GET')
            .then( res => {
                if( !res || res.err )
                    throw Error(res?.err||'empty response');
                tectransit.user = UserType.hydrate(res);
                setUser(tectransit.user);
            })
            .catch( err => {
                setErrMessage(`Cannot get user (${err.message})`);
            });
    },[refreshCount]);
    const driverSchedule = AgencyType.canonicalizeDriverSchedule(tectransit.agency.schedule_by_driver_id[user._id]||{});
    return MenuItem.withMenuItem("Schedule", (alert) => {
        if( errMessage )
            alert.set(errMessage);
        return (<div className="wrapper">
            <table style={{margin:'auto'}}>
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            Your schedule was last updated at <strong>{dayjs(user.schedule_changed_at).tz(tectransit.agency.time_zone).format(tectransit.timeFormat)}</strong>
                            <hr/>
                        </td>
                    </tr>
                    {Object.entries(driverSchedule).map( ([wd,ranges],endx) => {
                        return (
                            <tr key={endx}>
                                <td valign="top">
                                    <strong>{wd.replace(/^(.)(.*)$/,(...args) => `${args[1].toUpperCase()}${args[2]}`)}</strong>
                                </td>
                                <td valign="top">
                                    <table>
                                        <tbody>
                                        {(ranges?.length||0) ? ranges.map( (range,rndx) => {
                                            return (
                                                <tr key={rndx}><td>
                                                    From <strong>{hhmmUtil.getHHMMFromMins(range[0])}</strong>{" "}
                                                    to <strong>{hhmmUtil.getHHMMFromMins(range[1])}</strong>{" "}
                                                    vehicle #<strong>{range[2]}</strong>
                                                </td></tr>
                                            );
                                        }) : (
                                            <tr><td>
                                                (no schedule)
                                            </td></tr>
                                        )}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td colSpan={2}>
                            <hr/>
                            {(user.schedule_changed_at||0)<=(user.schedule_committed_at||0) ? (<>
                                You have already committed to this schedule at{" "}
                                <strong>{dayjs(user.schedule_committed_at).tz(tectransit.agency.time_zone).format(tectransit.timeFormat)}</strong>
                            </>) : (<button
                                type        = "button"
                                className   = "btn-theme btn-small"
                                onClick     = {(e:any) => {
                                    const userPatch = {
                                        schedule_committed_at : Date.now()
                                    };
                                    getApiPromise('/api/passenger/user','PUT',userPatch)
                                        .then( res => {
                                            if( !res || res.err )
                                                throw Error(res?.err||'empty response');
                                            setRefreshCount(refreshCount+1);
                                        })
                                        .catch( err => {
                                            alert.set(`Cannot update user (${err.message})`);
                                        });
                                }}>
                                    Press this button to acknowledge the receipt of this new schedule.
                            </button>)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>);
    });
}

export default Schedule;
